import { useRef } from 'react';
import algoliasearch from 'algoliasearch';
import algoliaSearchLite from 'algoliasearch/lite';
import { ALGOLIA_API_SEARCH_KEY, ALGOLIA_APP_ID } from '../constants';

/**
 * Returns a full version of the Algolia search client. This full version is
 * needed for non-search-related functionality, as well as for the use of
 * `multipleQueries` searches.
 * @param userPublicKey
 */
const useAlgoliaSearchClient = (userPublicKey?: string) => {
  const searchClient = useRef(algoliasearch(
    ALGOLIA_APP_ID!,
    userPublicKey || ALGOLIA_API_SEARCH_KEY!,
  ));
  return {
    searchClient: searchClient.current,
  };
};

/**
 * Returns a lite version of the Algolia search client. This lite version can
 * only be used for search-related functionality.
 * @param userPublicKey
 */
const useAlgoliaSearchClientLite = (userPublicKey?: string) => {
  const searchClientLite = useRef(algoliaSearchLite(
    ALGOLIA_APP_ID!,
    userPublicKey || ALGOLIA_API_SEARCH_KEY!,
  ));
  return {
    searchClient: searchClientLite.current,
  };
};

export {
  useAlgoliaSearchClient,
  useAlgoliaSearchClientLite,
};
